var styles = {"column":"navkit__FlexColumn__column","isMultiline":"navkit__FlexColumn__isMultiline","isFullwidth":"navkit__FlexColumn__isFullwidth","isCenter":"navkit__FlexColumn__isCenter"};

export { styles as default };
